<script setup>
import { useI18n } from 'vue-i18n';
import { useStore } from 'dashboard/composables/store';
import { useAlert, useTrack } from 'dashboard/composables';
import { CAMPAIGN_TYPES } from 'shared/constants/campaign.js';
import { CAMPAIGNS_EVENTS } from 'dashboard/helper/AnalyticsHelper/events.js';

import LiveChatCampaignForm from 'dashboard/components-next/Campaigns/Pages/CampaignPage/LiveChatCampaign/LiveChatCampaignForm.vue';
import Button from 'dashboard/components-next/button/Button.vue';

const emit = defineEmits(['close']);

const store = useStore();
const { t } = useI18n();

const addCampaign = async campaignDetails => {
  try {
    await store.dispatch('campaigns/create', campaignDetails);

    // tracking this here instead of the store to track the type of campaign
    useTrack(CAMPAIGNS_EVENTS.CREATE_CAMPAIGN, {
      type: CAMPAIGN_TYPES.ONGOING,
    });

    useAlert(t('CAMPAIGN.LIVE_CHAT.CREATE.FORM.API.SUCCESS_MESSAGE'));
  } catch (error) {
    const errorMessage =
      error?.response?.message ||
      t('CAMPAIGN.LIVE_CHAT.CREATE.FORM.API.ERROR_MESSAGE');
    useAlert(errorMessage);
  }
};

const handleClose = () => emit('close');

const handleSubmit = campaignDetails => {
  addCampaign(campaignDetails);
  handleClose();
};
</script>

<template>
  <Teleport to="body">
    <div
      role="dialog"
      aria-modal="true"
      class="tic-campaign-dialog fixed z-[10000] flex min-w-0 flex-col overflow-hidden rounded-xl border shadow-xl"
    >
      <div class="tic-campaign-dialog__header">
        <h3 class="m-0 text-base font-semibold text-n-slate-12">
          {{ t('CAMPAIGN.LIVE_CHAT.CREATE.TITLE') }}
        </h3>
        <Button
          ghost
          slate
          icon="i-lucide-x"
          type="button"
          @click="handleClose"
        />
      </div>
      <div class="tic-campaign-dialog__body">
        <LiveChatCampaignForm
          mode="create"
          @submit="handleSubmit"
          @cancel="handleClose"
        />
      </div>
    </div>
  </Teleport>
</template>
